import { useLogout } from "@refinedev/core";
import { Alert, Button, Card, Space, Typography } from "antd";
import { getSupabaseClient } from "../lib/supabase";

export function ForbiddenPage() {
	const { mutate: logout, isPending } = useLogout();

	return (
		<div
			style={{
				minHeight: "100vh",
				display: "grid",
				placeItems: "center",
				padding: 24,
				background: "#F8FAF9",
			}}
		>
			<Card style={{ maxWidth: 480, width: "100%" }}>
				<Space direction="vertical" size="middle" style={{ width: "100%" }}>
					<Typography.Title level={3} style={{ margin: 0 }}>
						アクセス権限がありません
					</Typography.Title>
					<Alert
						type="warning"
						showIcon
						message="このアカウントは管理スタッフとして登録されていません。招待を受けたアカウントでサインインしてください。"
					/>
					<Button
						type="primary"
						loading={isPending}
						onClick={() => {
							void getSupabaseClient().auth.signOut();
							logout();
						}}
					>
						ログアウト
					</Button>
				</Space>
			</Card>
		</div>
	);
}
